module.exports = __webpack_public_path__ + "static/Group_6106_2x-fe9f8317c94dd73a3f1471e828b21020.png";